import axiosInstance from '@/service/helpers/axios'
export async function getRelatedTag(id: number) {
  const result = await axiosInstance.get('/community-research/tag/list/' + id)
  return result
}
export async function addRelatedTag(body: { researchId: number; tagId: number }) {
  const result = await axiosInstance.post('/community-research/tag/create', body)
  return result
}
export async function removeRelatedTag(tagId: number) {
  const result = await axiosInstance.delete('/community-research/tag/remove/' + tagId)
  return result
}
